import script from "./CommunityView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityView.vue?vue&type=script&setup=true&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=d69c6972&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69c6972"]])

export default __exports__